import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

var SolidModal = function SolidModal(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  var children = props.children,
      className = props.className,
      show = props.show,
      hide = props.hide,
      exited = props.exited,
      title = props.title,
      _props$titleSize = props.titleSize,
      titleSize = _props$titleSize === void 0 ? "large" : _props$titleSize,
      titleColor = props.titleColor,
      locationColor = props.locationColor,
      backdrop = props.backdrop,
      size = props.size,
      _props$hideCloseButto = props.hideCloseButton,
      hideCloseButton = _props$hideCloseButto === void 0 ? false : _props$hideCloseButto,
      subtitle = props.subtitle;
  return /*#__PURE__*/React.createElement(BootstrapModal, {
    className: "solid-modal ".concat(className),
    show: show,
    onHide: hide,
    onExited: exited,
    backdrop: false,
    size: size,
    autoFocus: true,
    keyboard: true,
    onEntered: function onEntered() {
      setTimeout(function () {
        setIsModalVisible(true);
      }, 300);
    },
    onExit: function onExit() {
      return setIsModalVisible(false);
    }
  }, /*#__PURE__*/React.createElement(BootstrapModal.Header, {
    className: "solid-modal__header"
  }, /*#__PURE__*/React.createElement(BootstrapModal.Title, {
    className: "solid-modal__title"
  }, title), /*#__PURE__*/React.createElement(BootstrapModal.Title, {
    className: "solid-modal__subtitle"
  }, subtitle), !hideCloseButton && isModalVisible && /*#__PURE__*/React.createElement("button", {
    className: "solid-modal__close",
    onClick: hide
  }, /*#__PURE__*/React.createElement(IoMdClose, null))), /*#__PURE__*/React.createElement(BootstrapModal.Body, {
    className: "solid-modal__body"
  }, children));
};

export var ModalNoHeader = function ModalNoHeader(props) {
  var children = props.children,
      className = props.className,
      show = props.show,
      hide = props.hide,
      exited = props.exited,
      title = props.title,
      _props$titleSize2 = props.titleSize,
      titleSize = _props$titleSize2 === void 0 ? "large" : _props$titleSize2,
      backdrop = props.backdrop,
      size = props.size;
  return /*#__PURE__*/React.createElement(BootstrapModal, {
    className: className,
    show: show,
    onHide: hide,
    onExited: exited,
    backdrop: backdrop,
    size: size,
    autoFocus: true,
    keyboard: true
  }, /*#__PURE__*/React.createElement(BootstrapModal.Header, null, children, /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: hide
  }, "x")));
};
SolidModal.defaultProps = {
  title: "",
  backdrop: "static"
};
ModalNoHeader.defaultProps = {
  title: "",
  backdrop: "static"
};
export default SolidModal;